module.exports = __webpack_public_path__ + "img/bosch-rexroth.48e269b6.png";